import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import {
  Typography,
  IconButton,
  Grid,
  List,
  ListItem,
} from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

import { Image } from '@components/atoms';
import main_icon_negative from '@assets/images/main_icon_negative.png';


import { Config } from "@utils";
import { AppDetails } from "@helpers";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 0),
    },
    background: theme.palette.background.footer,
  },
  footerContainer: {
    maxWidth: theme.layout.contentWidth,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 8),
    },
  },
  logoContainerItem: {
    paddingTop: 0,
  },
  logoContainer: {
    width: 130,
    height: 35,
  },
  logoImage: {
    width: '100%',
    height: '100%',
  },
  groupTitle: {
    textTransform: 'uppercase',
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(1),
  },
  socialIcon: {
    padding: 0,
    marginRight: theme.spacing(1),
    color: 'rgba(255,255,255,.6)',
    '&:hover': {
      background: 'transparent',
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  icon: {
    fontSize: 24,
  },
  menuListContainer: {
    padding: '0 !important',
  },
  menu: {
    display: 'flex',
  },
  menuItem: {
    margin: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  menuGroupItem: {
    paddingTop: 0,
    paddingBottom: theme.spacing(1 / 2),
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  menuGroupTitle: {
    textTransform: 'uppercase',
    color: 'white',
  },
  divider: {
    width: '100%',
  },
  navLink: {
    color: 'rgba(255,255,255,.6)',
  },
  center: {
    alignItems: 'center',
  },
}));

const Footer = props => {

  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.footerContainer}>
        <Grid container spacing={2} className={classes.center}>
          <Grid item xs={12} md={10}>
            <List disablePadding>
              <ListItem disableGutters className={classes.logoContainerItem}>
                <div className={classes.logoContainer}>
                  <a href="https://www.globalmedicalresponse.com/" target="_blank" rel="noopener noreferrer">
                    <Image
                      className={classes.logoImage}
                      src={main_icon_negative}
                      lazy={false}
                    />
                  </a>
                </div>
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={8} md={2}>
            <List disablePadding>
              <ListItem disableGutters>
                <Link to={{ pathname: "https://www.facebook.com/GlobalMedicalResponse" }} target="_blank" rel="noopener noreferrer">
                  <IconButton className={classes.socialIcon}>
                    <FacebookIcon className={classes.icon} />
                  </IconButton>
                </Link>
                <Link to={{ pathname: "https://www.instagram.com/Global_Medical_Response/" }} target="_blank" rel="noopener noreferrer">
                  <IconButton className={classes.socialIcon}>
                    <InstagramIcon className={classes.icon} />
                  </IconButton>
                </Link>
                <Link to={{ pathname: "https://twitter.com/GMR_Social" }} target="_blank" rel="noopener noreferrer">
                  <IconButton className={classes.socialIcon}>
                    <TwitterIcon className={classes.icon} />
                  </IconButton>
                </Link>
                <Link to={{ pathname: "https://www.linkedin.com/company/global-medical-response/" }} target="_blank" rel="noopener noreferrer">
                  <IconButton className={classes.socialIcon}>
                    <LinkedInIcon className={classes.icon} />
                  </IconButton>
                </Link>
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={4} md={10} className={classes.menuListContainer}>
            <Typography variant="body2" className={clsx(classes.navLink)}>
              <span>{Config.currentAppVersion}-{AppDetails.currentBuildVersion()}</span>
            </Typography>
          </Grid>

        </Grid>
      </div>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.object.isRequired,
};

export default Footer;